<template>
  <page-article>
    <div class="col-12 page_content_area">
      <div class="container">
        <div class="page_article_block col-12">
          <div class="col-12">
            <div class="page_title">
              博覽會攤位配置圖
            </div>
          </div>
          <div class="col-12 article_info_item">
            <span class="article_tag">詳細內容</span>
          </div>
          <div class="col-12 article_content">
            <div
              v-if="currentExpoDetailsGetter.expo_content"
              v-html="currentExpoDetailsGetter.expo_content"
            />
            <p v-else>
              尚未上傳圖片
            </p>
          </div>
          <template
            v-if="canViewBooths"
          >
            <div class="col-12 article_info_item">
              <span class="article_tag">攤位列表</span>
            </div>
            <div
              class="article_content"
            >
              <template>
                <booth-list-table
                  read-only
                  @update:page="updateBoothList"
                />
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
  </page-article>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import pageArticle from '~components/pages/Article'
import BoothListTable from './common/BoothListTable'

export default {
  name: 'CareerExpoDetailsContent',
  components: {
    pageArticle,
    BoothListTable
  },
  computed: {
    ...mapGetters('pages/campus-recruiting', [
      'currentExpoDetailsGetter'
    ]),
    canViewBooths () {
      if (
        Object.keys(this.currentExpoDetailsGetter).includes('expo_enrollment_start_date')
      ) {
        return this.$moment().isAfter(this.currentExpoDetailsGetter.expo_enrollment_start_date) &&
          Boolean(this.currentExpoDetailsGetter.expo_enrollment_available)
      } else {
        return false
      }
    }
  },
  async created () {
    this.togglePageLoader(true)
	try {
		await this.getExpoDetailsById({ id: this.$route.params.id });
	}
	catch (err) {
		this.$router.push('/campus-recruiting');
	}
    this.togglePageLoader(false)
  },
  methods: {
    ...mapActions('pages/campus-recruiting', [
      'getExpoDetailsById'
    ]),
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    async updateBoothList (page) {
      this.togglePageLoader(true)
      await this.getExpoDetailsById({
        id: this.$route.params.id,
        page: page || 1
      })
      this.togglePageLoader(false)
    }
  }
}
</script>
